<script>
import {mapActions} from 'vuex'

export default {
	data() {
		return {
			code: ''
		}
	},
	methods: {
		show() {
			const vm = this
			$(vm.$el).modal('show')
		},
		
		hide() {
			const vm = this
			$(vm.$el).modal('hide')
		},

		async unlockWithCode() {
			const vm = this
			try {
				let data = await vm.checkCode(vm.code)
				vm.$snotify.success('Contenido desbloqueado')
				vm.hide()
			} catch (error) {
				console.log(error)
				vm.$snotify.error(error.message)
			}
		},

		...mapActions({
			checkCode: 'activities/checkCode'
		})
	}
}
</script>
<template>
	<div class="modal fade" id="lockModal" tabindex="-1" role="dialog" aria-labelledby="lockModalLabel" aria-hidden="true">
		<div class="modal-dialog modal-dialog-centered" role="document">
			<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="lockModalLabel">Este contenido esta bloqueado</h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
				<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<p>¿Tienes un código de acceso?</p>
				<input class="form-control" placeholder="Escribe código de acceso" type="text" v-model="code">
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
				<button type="button" class="btn btn-primary" @click="unlockWithCode">Desbloquear</button>
			</div>
			</div>
		</div>
	</div>
</template>